// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import './index.css';
import App from './App';

// В dev запросы идут напрямую на Node (5001), в prod — proxy/same-origin
if (process.env.REACT_APP_API_URL) {
  axios.defaults.baseURL = process.env.REACT_APP_API_URL;
}

// Редирект на /frozen при 403 FROZEN/TRIAL_EXPIRED
// НО только из админки — гостей на /menu НЕ редиректим!
axios.interceptors.response.use(
  (r) => r,
  (err) => {
    const code = err.response?.data?.code;
    if (err.response?.status === 403 && (code === 'FROZEN' || code === 'TRIAL_EXPIRED')) {
      const path = window.location.pathname;
      const isAdminRoute =
        path.startsWith('/admin') ||
        path.startsWith('/superadmin') ||
        path.startsWith('/staff') ||
        path.startsWith('/courier');
      if (isAdminRoute) {
        window.location.href = `/frozen?code=${code}`;
      }
    }
    return Promise.reject(err);
  }
);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(<App />);

// PWA: в production регистрируем пустой SW (установка / standalone в Chrome)
if (process.env.NODE_ENV === 'production' && typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    const u = `${process.env.PUBLIC_URL || ''}/sw.js`;
    navigator.serviceWorker.register(u).catch(() => {});
  });
}